import React from 'react';
import StoryGallery from '../components/StoryGallery';
import styles from '../styles/Design_Lab.module.css';

const StoryLab = () => (
    <div className={styles.pageContainer}>
        <StoryGallery />
    </div>
);

export default StoryLab;
